import React, { useState, useEffect } from "react";
import { Route, Redirect } from "react-router-dom";
import Sidebar from "./components/Sidebar";
import { isLoggedIn } from "./utils/utils";
// import { db, getCheckSession, logout } from "./apis/auth";

const PrivateRoute = ({ component: Component, ...rest }) => {
  // const [loginStatus, setLoginStatus] = useState(true);
  // useEffect(async () => {
  //   console.log("========== LiveMeterFeed : OnInit() ==========");
    
  //   await getCheckSession().then(() => {
  //     setLoginStatus(true);
  //   }).catch((e) => {
  //     setLoginStatus(false);
  //   });
  // }, []);

  return (
    <>
      <Sidebar />
      <main className="main-content" style={{minWidth:1200}}>
        <Route
          {...rest}
          render={(props) => {
            return isLoggedIn ? (
              <Component {...props} />
            ) : (
              <Redirect to="/" />
            );
          }}
        />
      </main>
    </>
  );
};

export default PrivateRoute;
